module.exports = __webpack_public_path__ + "img/map_corner-pavilion.34fa9176.jpg";